
import SeoDataMixin from '@Mixins/seo-data';
import errorHandler from '@Utils/error-handler';
import { adapterMealIdeas } from '@Adapters/cms/meal-ideas.adapter';

export default {
  name: 'MealIdeasPage',
  mixins: [SeoDataMixin],
  async asyncData(context) {
    const { $publicAPI, error, route } = context;

    try {
      const data = await $publicAPI.cms.getEntry('recipe_ideas_page', {
        params: {
          targetPage: route.path,
        },
      });
      const pageData = adapterMealIdeas(data, context);

      if (!pageData) {
        return error({ statusCode: 404 });
      }

      return pageData;
    } catch (err) {
      errorHandler(err, context, {
        logOnly: true,
        path: 'pages.edito.meal-ideas.asyncData',
      });

      return error(err);
    }
  },
  data() {
    return {
      bannerApp: undefined,
      editoMedia: undefined,
      editoPush: undefined,
      footnotes: undefined,
      header: undefined,
      headerVideo: undefined,
      mediaBlock: undefined,
      navigation: undefined,
      serviceList: undefined,
      text: undefined,
    };
  },
};
